module.exports = __webpack_public_path__ + "img/four.4739b1e5.png";